import React from 'react';
import './Headerbar.scss';

interface Props {
  title: string;
  search?: string;
  onSearch?: (msg: string) => void;

  renderButtons?: any;
}
const Headerbar: React.FC<Props> = (props) => {
  /*return (
    <div className="headerbar">
      <div className="title">{props.title}</div>
      { props.renderButtons ? props.renderButtons() : null }
    </div>
  );*/
  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <ul className="navbar-nav">
        <li className="nav-item">
          <span style={{cursor: 'pointer'}} className="nav-link" data-widget="pushmenu"><i className="fas fa-bars"></i></span>
        </li>
      </ul>

      { props.onSearch ? (
        <form className="form-inline ml-3">
          <div className="input-group input-group-sm">
            <input
              value={props.search || ''}
              onChange={(evt) => props.onSearch!(evt.target.value)}
              className="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search" />
            <div className="input-group-append">
              <button className="btn btn-navbar" type="submit">
                <i className="fas fa-search"></i>
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div>{props.title}</div>
      )}

      <div className="header-right">
        { props.renderButtons && props.renderButtons() }
      </div>

    </nav>
  )
}

export default Headerbar;
